(function () {
'use strict';

angular
    .module('controlEditRoutes', [
        'controlEditModule',
        'controlModule',
        'observationModule'
    ])
    .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

              // Control Add
              .state('controlAdd', {
                  url: '/Control/Add',
                  templateUrl: require('./controlAdd.tpl.html'),
                  controller: 'ControlAddController'
              })

             // Control Not Exists
             .state('controlNotExists', {
                 url: '/Control/{ControlID:int}/NotExists',
                 templateUrl: require('./controlNotExists.tpl.html')
             })

             // Control Edit
             .state('control', {
                 url: '/Control/{ControlID:int}',
                 params: historyCtxtServiceProvider.getStateParamsConfig(),
                 resolve: {
                     govProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveARIC();
                     }],
                     control: ['$stateParams', 'grcControlService', function ($stateParams, service) {
                         return service.getControl($stateParams.ControlID);
                     }],
                 },
                 views: {
                     '': {
                         template: '<div ui-view="mainContent"></div>',
                         controller: 'ControlEditController',
                     },
                     'mainContent@control': {
                         templateUrl: require('./controlEdit.tpl.html')
                     }
                 }
             })

            .state('control.observations', {
                url: '/Observation',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlObservationList.tpl.html'),
                        controller: 'ControlObservationListController',
                    }
                }
            })

            // Control Assessment
            .state('control.assessment', {
                url: '/Assessment',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlAssessment.tpl.html'),
                    }
                }
            })

            // Control Review
            .state('control.review', {
                url: '/Review',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlReview.tpl.html'),
                    }
                }
            })

            // Related Risks
            .state('control.relatedRisks', {
                url: '/RelatedRisk',
                resolve: {
                    risks: ['$stateParams', 'grcControlService', function ($stateParams, service) {
                        return service.getRisksByControl($stateParams.ControlID);
                    }],
                },
                views: {
                    'mainContent@control': {
                        templateUrl: require('./relatedRisks.tpl.html'),
                        controller: 'ControlRelatedRisksController',
                    }
                }
            })

            // Control History
            .state('control.history', {
                url: '/History',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlHistory.tpl.html'),
                        controller: 'ControlHistoryController',
                    }
                }
            })

            // Control Test
            .state('control.controlTests', {
                url: '/ControlTest',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlTestList.tpl.html'),
                    }
                }
            })

            .state('control.addControlTest', {
                url: '/ControlTest/Add',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlTest.tpl.html'),
                        controller: 'ControlTestController',
                        resolve: {
                            controlTest: ['control', function (control) {
                                return {
                                    ControlID: control.ControlID
                                };
                            }],
                            testResults: [function () {
                                return null;
                            }]
                        }
                    }
                }
            })

            .state('control.controlTests.edit', {
                url: '/{ControlTestID:int}',
                resolve: {
                    controlTest: ['$stateParams', 'grcControlService', function ($stateParams, service) {
                        return service.getControlTest($stateParams.ControlTestID);
                    }],
                    testResults: ['grcControlService', 'controlTest', function (service, controlTest) {
                        if (controlTest && controlTest.ControlTestID && controlTest.ControlID) {
                            return service.getTestResults(controlTest.ControlID, controlTest.ControlTestID);
                        }
                        return null;
                    }]
                },
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlTest.tpl.html'),
                        controller: 'ControlTestController'
                    }
                }
            })

            .state('control.controlTests.edit.testresult', {
                url: '/TestResult',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./testResult.tpl.html'),
                        controller: 'ControlTestController'
                    }
                }
            })

            // Observations
            .state('control.controlTests.edit.observations', {
                url: '/Observation',
                views: {
                    'mainContent@control': {
                        templateUrl: require('./controlTestObservationList.tpl.html'),
                        controller: 'ControlTestObservationListController'
                    }
                }
            });

        // History Context
        historyCtxtServiceProvider.setCtxtState('control',
            '/app/Main/grcEdit/control/GOVHistoryCtxtDirective-control.tpl.html'
        );
    }
})();
